export default "__VITE_ASSET__acaf59ed__"